'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { formatTimeAgo } from '@/shared/utils/format/formatTimeAgo.mjs';

/**
 * Live "Updated Xs ago" counter. Ticks every second; resets naturally when
 * `lastUpdated` changes (e.g. the next poll arrives).
 */
export default function LastUpdated(t0) {
  const $ = _c(7);
  const {
    lastUpdated
  } = t0;
  const [now, setNow] = useState(_temp);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const id = setInterval(() => setNow(Date.now()), 1000);
      return () => clearInterval(id);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!lastUpdated) {
    return null;
  }
  let t3;
  if ($[2] !== lastUpdated || $[3] !== now) {
    t3 = formatTimeAgo(lastUpdated, new Date(now));
    $[2] = lastUpdated;
    $[3] = now;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <span className="font-mono text-small text-[var(--color-text-muted)]" suppressHydrationWarning={true}>{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp() {
  return Date.now();
}